export enum UserTypeEnum {
  PRODUCER = 1,
  CUSTOMER = 2,
  PRODUCER_EMPLOYEE = 3,
  CUSTOMER_EMPLOYEE = 4,
  LOGICAL_ASSISTANT = 5,
  VEILING_EMPLOYEE = 6
}
